






































































































import InteractionModal from './InteractionModal.vue';
import MAFDropdown from '../common/MAFDropdown.vue';
import { violationState } from '../../store/Violations';
import {Lookup, LookupIcon} from '@/store/types';
import {Prop, Emit, Ref, Vue, Watch} from 'vue-property-decorator';
import AdminNavBar from './AdminNavBar.vue';
import Component, {mixins} from 'vue-class-component';
import {MAFUser} from '@/store/User/types';
import {Action, Mutation, namespace, Getter, State} from 'vuex-class';
import BModal from 'buefy/src/components/modal/Modal.vue';
import ModalTemplate from '@/components/common/ModalTemplate.vue';
import {modalTemplate} from '@/components/common/types';
import BTable from 'buefy/src/components/table/Table.vue';
import luxon from '@/plugins/luxon';
import {DateTime} from 'luxon';
import * as _ from 'lodash';
import {MAFViolation} from '@/store/Violations/types';
import * as firebase from 'firebase/app';

const violationsPath = 'violationState';
const violationsNamespace = namespace(violationsPath);

const userPath = 'userState';
const userNamespace = namespace(userPath);

@Component({
        components: {
            AdminNavBar, BModal, ModalTemplate,
            BTable, InteractionModal, MAFDropdown,
        },
    })
  /* tslint:disable:no-console */
    export default class AdminViolation extends Vue {
        @Prop(String) public readonly route!: string;
        @violationsNamespace.State('resolutions') public Resolutions !: Lookup;
        @violationsNamespace.State('violations') public Violations !: MAFViolation[];
        @violationsNamespace.Action('getMAFViolations') public getMAFViolations: any;
        @violationsNamespace.Action('updateMAFViolations') public updateMAFViolations: any;
        @violationsNamespace.Action('getResolutions') public getResolutions: any;
        @violationsNamespace.Getter('getResolutions') public Resolution: string[] | undefined;
        @userNamespace.Action('setUserBan') public setUserBan!: any;
        @userNamespace.Action('updateUser') public updateUser!: any;

        public currentPage: number = 1;
        public checkboxPosition: any = 'left';
        public hasMobileCards: boolean = true;
        public showInteraction: boolean = false;
        public defaultSortDirection: any = 'desc';
        public resolutionOptions: any[] = [];
        public selectedUser: any = [];
        public selectedViolation: any = [];

        constructor() {
            super();
        }
        public async created() {
          await this.getMAFViolations();
          await this.getResolutions();

          if (this.Resolution) {
            // update the resolutions to be more than just a string
            this.resolutionOptions = this.Resolution.map((r) => ({
              value: r,
              text: r,
            }));
            // added an 'undefined' option to the front as the default dropdown option
            // <option> now has a :value field which allows the <select> to show the right option
            this.resolutionOptions.unshift({ value: '', text: 'Set Resolution' });
          }
        }
        public formatDate(date: Date) {
            return DateTime.fromJSDate(date).toFormat(' LLLL d yyyy t');
        }
        public capitalize(name: string) {
            // const nameArray = name.split(' ');
            // const firstName = nameArray[0].charAt(0).toUpperCase() + nameArray[0].slice(1);
            // if (nameArray.length === 1) { return firstName; }
            // return `${firstName} ${nameArray[1][0].toUpperCase()}.`;
        }
        public data() {
          return {
            showDetailIcon: true,
            checkable: true,
          };
        }
        public closeInteraction() {
            this.$router.push('/admin');
        }
        public openInteraction(user: MAFUser, violation: MAFViolation) {
            this.showInteraction = true;
            this.selectedUser = user;
            this.selectedViolation = violation;
        }

        // update a violation with resolution type, occurs on button click
        // TODO: pass the selected resolution string to replace hardcoded value
        public async updateViolation(violation: MAFViolation, user: MAFUser, reso: string) {
          if (reso.toLowerCase() === 'ban user') {
            this.onBanUser(user);
          }
          if (violation) {
             await this.updateMAFViolations(violation);
          }
        }
        public async onBanUser(user: MAFUser) {
          if (user.Reference) {
            try {
                // user is always banned at this option,
                // if the admin accidentally sets this twice it wont unban someone.
                user.isBanned = true;
                return await user.Reference.update(user.toPlainObj());
            } catch (error) {
                console.log(error);
                return error;
            }

          } else {
            user.isBanned = true;
            const friendDocumentRef = Vue.prototype.$firestore.collection('users').doc(user.uid);
            friendDocumentRef.set(user, {merge: true});
            this.updateUser(user);
          }
        }
    }
